import * as _ from 'lodash'
import {PeriodBO} from "./PeriodBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {WB_PeriodRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Period} from "../PA.Core/PAdbSchema";


export class PeriodBOValidations {


    static async ValidateFields(aBO: PeriodBO): Promise<void> {

            let bDateOrderingIncorrect = false
            let bEmptyStartDate = false
            let bEmptyEndDate = false
            let dbContext = new PAdbContext({})


            // Validate Period Name
            if (_.isEmpty(aBO.WB_Period.cif.PERIOD_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyName',
                        type: MessageType.Error,
                        title: "Period Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyName')
            }

            if (_.isEmpty(aBO.WB_Period.cif.PERIOD_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyID',
                        type: MessageType.Error,
                        title: "Period ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyID')
            }


            if (_.isDate(aBO.WB_Period.PeriodStartDt) && _.isDate(aBO.WB_Period.PeriodEndDt)) {
                if (aBO.WB_Period.PeriodEndDt < aBO.WB_Period.PeriodStartDt) {
                    bDateOrderingIncorrect = true
                }
            }



            if (bDateOrderingIncorrect) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'PeriodDateOrderingIncorrect',
                        type: MessageType.Error,
                        title: "Start date must be before the End date",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('PeriodDateOrderingIncorrect')

            }

            if (_.isEmpty(aBO.WB_Period.cif.PERIOD_START_DT)) {
                bEmptyStartDate = true
            }

            if (_.isEmpty(aBO.WB_Period.cif.PERIOD_END_DT)) {
                bEmptyEndDate = true
            }

            if (bEmptyStartDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyStartDate',
                        type: MessageType.Error,
                        title: "Start Date cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyStartDate')
            }

            if (bEmptyEndDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyEndDate',
                        type: MessageType.Error,
                        title: "End Date cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyEndDate')
            }


            // Periods are considered duplicates only within the same Master Data Set
            let periodRows: WB_PeriodRow[] = await dbContext.findAll(esWB_Period,
                {where: {DELETED_IND: {neq: '1'},
                        WB_PERIOD_ID: {neq: aBO.WB_Period.cif.WB_PERIOD_ID},
                        WB_MDSET_ID: aBO.WB_Period.cif.WB_MDSET_ID,
                        PERIOD_ID: aBO.WB_Period.cif.PERIOD_ID}})

            //Duplicate ID/Name combo
            let periodRowsIDName: WB_PeriodRow[] = await dbContext.findAll(esWB_Period,
                {where: {DELETED_IND: {neq: '1'},
                        WB_PERIOD_ID: {neq: aBO.WB_Period.cif.WB_PERIOD_ID},
                        WB_MDSET_ID: aBO.WB_Period.cif.WB_MDSET_ID,
                        PERIOD_ID: aBO.WB_Period.cif.PERIOD_ID,
                        PERIOD_NAME: aBO.WB_Period.cif.PERIOD_NAME,
                    }})
            if (!_.isEmpty(periodRowsIDName)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'duplicateIDName',
                        type: MessageType.Error,
                        title: 'Existing Period with the same ID and Name: ' +
                                                '\\nPeriod: ' + _.map(periodRowsIDName, (a) => `${a.cif.PERIOD_NAME} (${a.cif.PERIOD_ID})`).join(","),
                        description: "",
                        subtitle: "",
                        count: 0
                    })
                return
            } else {
                aBO.ValidateMessageProvider.removeMessage("duplicateIDName")
            }

            if (!_.isEmpty(periodRows)) {
                aBO.ValidateMessageProvider.addMessage({
                    code: "duplicateID", type: MessageType.Error,
                    title: 'Existing Period with the same ID: ' +
                        '\nPeriod: ' + _.map(periodRows, (a) => `${a.cif.PERIOD_NAME} (${a.cif.PERIOD_ID})`).join(","),
                    description: "",
                    subtitle: "",
                    count: 0
                })
            } else {
                aBO.ValidateMessageProvider.removeMessage("duplicateID")
            }





    }
}
